// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"486":"6549fbae","607":"edbbe01a"}[chunkId] + ".chunk.js";
};